import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "toggleIcon"]

  toggle() {
    const input = this.inputTarget
    if (input.type === "password") {
      input.type = "text"
      if (this.hasToggleIconTarget) {
        this.toggleIconTarget.classList.replace("fa-eye", "fa-eye-slash")
      }
    } else {
      input.type = "password"
      if (this.hasToggleIconTarget) {
        this.toggleIconTarget.classList.replace("fa-eye-slash", "fa-eye")
      }
    }
  }

  copy() {
    const input = this.inputTarget
    const previousType = input.type
    input.type = "text"
    input.select()
    input.setSelectionRange(0, 99999)
    try {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(input.value)
      } else {
        document.execCommand("copy")
      }
    } finally {
      input.type = previousType
      window.getSelection().removeAllRanges()
    }
  }
}
